import React from "react";
import Template from './Template';
import Container from "../Container";

const Layout = (Template) => {
  return class extends React.Component {
    content = {
      notes: null,
      gageSeriesData: {
        description: null
      },
      gagePatternData: {
        designation: null,
        resistance: null,
        options: null
      }
    };

    constructor(props) {
      super(props);
      if (Array.isArray(props.content?.pages)) {
        this.state = {
          pages: props.content.pages.map(p => ({
            ...p, contentRef: React.createRef()
          }))
        };
      } else {
        this.state = {
          pages: [{
            gagePatternData: true,
            gageDimensions: true,
            gageSeriesData: true,
            notes: true,
            imgSrc: null,
            contentRef: React.createRef()
          }]
        };
      }
      const { pages, ...restContent } = props.content;
      if (restContent.length) {
        this.content = {...this.content, ...restContent};
      }
      const actualSizeImgSet = this.state.pages
        .reduce((r, p) => r || !!p.imgSrc, false);
      props.changeRemoved('actualSize', !actualSizeImgSet);
    }

    changeContent(pages) {
      const cleanPages = pages.map(p => {
        const { contentRef, ...rest } = p;
        return rest;
      });
      this.props.changeContent('pages', cleanPages);
    }

    setContent = (id, value) => {
      this.content[id] = value;
      this.props.changeContent(id, value);
    };

    onImgSelected = (index, value) => {
      const pages = [...this.state.pages];
      pages[index].imgSrc = value;
      this.changeContent(pages);
      this.setState({pages});
      this.props.changeRemoved('actualSize', false);
    };

    onContentOverflow = (index, height) => {
      const contentRef = this.state.pages[index]?.contentRef;
      if (contentRef.current) {
        const children = contentRef.current.children;
        let slicedHeight = 0;
        let slicedElements = [];

        for (let i = children.length - 1; i >= 0 && slicedHeight <= height; --i) {
          slicedHeight += children[i].scrollHeight;
          slicedElements.push({id: children[i].id, text: 'sd'});
        }

        if (slicedElements.length) {
          slicedElements.forEach((e) => {
            this.state.pages[index][e.id] = false;
          });
          let nextPage = this.state.pages[index + 1] || {
            contentRef: React.createRef()
          };
          nextPage = {
            ...nextPage,
            ...slicedElements.reduce((r, e) => ({...r, [e.id]: true}), {})
          };

          if (this.state.pages.length - 1 <= index) {
            this.changeContent([...this.state.pages, nextPage]);
            this.setState({
              pages: [...this.state.pages, nextPage]
            });
          } else {
            this.changeContent( [...this.state.pages.slice(0, -1), nextPage]);
            this.setState({
              pages: [...this.state.pages.slice(0, -1), nextPage]
            });
          }
        }
      }
    };

    onContentLack = (index, height) => {
      const currContentRef = this.state.pages[index]?.contentRef;
      const nextContentRef = this.state.pages[index + 1]?.contentRef;
      const currChildren = currContentRef?.current?.children;
      const nextChildren = nextContentRef?.current?.children;

      if (currChildren && nextChildren) {
        let slicedHeight = nextChildren[0]?.scrollHeight || 0;
        let slicedElements = [];

        for (let i = 0; i < nextChildren.length && slicedHeight <= height; ++i) {
          slicedHeight += nextChildren[i]?.scrollHeight || 0;
          slicedElements.push({id: nextChildren[i].id, text: 'sd'});
        }

        if (slicedElements.length) {
          slicedElements.forEach((e) => {
            this.state.pages[index][e.id] = true;
            this.state.pages[index + 1][e.id] = false;
          });
          const newPages = [...this.state.pages]
            .filter(e => e.gagePatternData
              || e.gageDimensions
              || e.gageSeriesData
              || e.notes);

          this.changeContent(newPages);
          this.setState({
            pages: newPages
          });
        }
      }
    };

    render() {
      const { pages, ...restContent } = this.props.content;
      return (
        <Container containerRef={this.props.containerRef}>
          {this.state.pages.map((props, i) => (
            <Template
              {...props}
              product={this.props.product}
              content={restContent}
              setContent={this.setContent}
              onImgSelected={this.onImgSelected}
              onContentOverflow={this.onContentOverflow}
              onContentLack={this.onContentLack}
              removableArea={this.props.removableArea}
              index={i}
              key={i}
            />
          ))}
        </Container>
      );
    }
  }
};

export default Layout(Template);
